// extracted by mini-css-extract-plugin
export default {"countryBadgeContainer":"CountryBadge_countryBadgeContainer__fx6Qh","countryImage":"CountryBadge_countryImage__V3Aps","countryName":"CountryBadge_countryName__N-CLc"};